import { Pipe, PipeTransform } from '@angular/core';
import { AssetStatus } from '@picflow/types';

@Pipe({
  name: 'galleryIsApproveOnly',
  standalone: true,
})
export class GalleryIsApproveOnlyPipe implements PipeTransform {
  transform(enabledStatuses: AssetStatus[]): boolean {
    if (!enabledStatuses) return false;
    if (enabledStatuses.length !== 2) return false;
    return enabledStatuses.includes('approved');
  }
}
